import { ExperienceTemplateRendererComponentLibrary } from 'experience-template-renderer-react';

import { UitkComponent } from './uitk-component';

import { CustomerNotificationTemplateComponent } from './customer-notication-template-component';
import { DynamicSearchMapWrapper } from '../map/dynamic-search-map-wrapper';
import { Filterbar } from '../filterbar';
import { Footer } from '@gc/global-components';
import { FullWidthSiteHeader } from './full-width-site-header';
import { ListViewLayout } from './list-view-layout';
import { MainRegion } from './main-region';
import { MesoScripts } from 'components/meso/internals/meso-scripts';
import { MesoSideRail } from 'components/meso/meso-side-rail';
import { MitHeader } from 'components/multi-item/multi-item-header';
import { Playback } from 'components/search/playback/playback';
import { ResultsHeader } from 'components/search/results-header';
import { SplitViewResultsHeader } from 'components/search/split-view-results-header';
import { ResultsWrapper } from './results-wrapper';
import { SearchResultsWrapper } from 'components/search/results/search-results-wrapper';
import { SidebarWrapper } from './sidebar-wrapper';
import { SideRailRegion } from './side-rail-region';
import { SRPLayout } from './srp-layout';
import { ToolbarRegion } from './toolbar-region';

export const componentLibrary: ExperienceTemplateRendererComponentLibrary = new Map()
  .set('SearchResultsWrapper', SearchResultsWrapper)
  .set('ResultsHeader', ResultsHeader)
  .set('SplitViewResultsHeader', SplitViewResultsHeader)
  .set('Sidebar', SidebarWrapper)
  .set('ToolbarRegion', ToolbarRegion)
  .set('Playback', Playback)
  .set('MainRegion', MainRegion)
  .set('ResultsWrapper', ResultsWrapper)
  .set('MitHeader', MitHeader)
  .set('CustomerNotificationTemplateComponent', CustomerNotificationTemplateComponent)
  .set('SideRailRegion', SideRailRegion)
  .set('MesoSideRail', MesoSideRail)
  .set('UitkComponent', UitkComponent)
  .set('Filterbar', Filterbar)
  .set('DynamicSearchMapWrapper', DynamicSearchMapWrapper)
  .set('ListViewLayout', ListViewLayout)
  .set('FullWidthSiteHeader', FullWidthSiteHeader)
  .set('Footer', Footer)
  .set('SRPLayout', SRPLayout)
  .set('MesoScripts', MesoScripts);
